<template>
  <div>
    <div class="panel no-padding">
      <searchBar placeholder="Search line items" @sort="sort"
                 :value="searchValue" :dateFilter="true"
                 @search="search" @dateFilter="dateFilter"
                 @paidFilter="paidFilter"></searchBar>

      <div :class="['loading-area', loading ? 'loading' : '']">
        <div :class="['loading-area__content', loading ? 'loading' : '']">
          <pagination :prev="prev" :next="next" :start="start" :end="end"
                      :total="total" @paginate="paginate"></pagination>

          <tableList :header="tableHeader" :data="tableData" :loading="loading"
                     classes="no-hover" @sort="orderBy"
                     @callback="callback"></tableList>

          <pagination :prev="prev" :next="next" :start="start" :end="end"
                      :total="total" @paginate="paginate"></pagination>
        </div>
      </div>
    </div>

    <div class="panel" v-if="!loading && tableData.length === 0">
      <p>Vendor does not currently have any commissions.</p>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="editingCommission">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Set Commission</h3>

              <span class="overlay__close" @click="closeCommission">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <input id="line-item-id" name="id" type="hidden">

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="commission-override">Set Commission</label>
                    </div>

                    <div class="cell auto">
                      <input id="commission-override" class="short-input"
                             name="commission"
                             type="text" :value="editingCommissionValue">
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeCommission">Cancel
              </button>

              <button @click="saveCommission()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pagination from '@/globals/pagination'
import tableList from '@/globals/tableList'
import paginationUtils from '@/mixins/paginationUtils'
import payout from '@/globals/payout'
import customItem from '@/globals/customItem'
import moment from 'moment'

export default {
  mixins: [paginationUtils],
  props: [
    'vendorId',
    'vendorName',
    'vendorPayPalEmail',
    'noPayments'
  ],
  components: {
    pagination,
    tableList,
    payout,
    customItem
  },
  data: function () {
    return {
      payments: true,
      canpayments: true,
      addCustomItem: false,
      undoSelectAll: false,
      selectedAll: false,
      selectedOrders: 0,
      reviewPayout: false,
      reviewLineItems: [],
      payoutTotal: 0.00,
      editingCommission: false,
      editingVendor: false,
      editingCommissionValue: '',
      order: {
        name: '#0000',
        url: '#'
      },
      date: 'Jan 1, 1970 at 0:00am',
      financialLabel: '',
      financialStatus: 'Payment',
      fulfillmentLabel: '',
      fulfillmentStatus: 'Fulfillment',
      price: 0,
      action: '/vendors/unpaid-commissions/?vendor_id=' + this.vendorId,
      params: {},
      sort: '-order__processed_at',
      tableHeader: {
        checkbox: false,
        data: [
          {
            label: 'Order',
            sort: 'order__name'
          },
          {
            label: 'Product',
            class: 'full',
            sort: 'variant__product__title'
          },
          {
            label: 'Location',
            class: 'medium'
          },
          // {
          //   label: 'Customer',
          //   class: 'medium show-for-xlarge'
          // },
          // {
          //   label: 'Fulfillment',
          //   class: 'medium'
          // },
          {
            label: 'Price'
          },
          {
            label: 'Item Cost',
            class: 'show-for-xlarge'
          },
          {
            label: 'Commission'
          },
          {
            label: 'Date',
            class: 'large show-for-xlarge'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    addItem () {
      this.addCustomItem = true
    },
    closeCustomItem (updated) {
      this.addCustomItem = false

      if (updated) {
        this.getData()
      }
    },
    exportCommissions () {
      this.loading = true

      this.request('get', '/vendors/commissions/', {
        vendor_id: this.vendorId,
        paid: this.params['paid'],
        page_size: 1000,
        date_start: this.params['date_start'],
        date_end: this.params['date_end'],
        ordering: '-order__processed_at',
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    itemsSelected (all = false) {
      let lineItems = document.getElementsByClassName('checkbox-choice')

      let ids = []
      this.payoutTotal = 0.00

      for (let i = 0; i < lineItems.length; i++) {
        if (lineItems[i].classList.contains('active')) {
          if (lineItems[i].dataset.id !== null && lineItems[i].dataset.id !== undefined) {
            for (let j = 0; j < this.data.length; j++) {
              if (parseInt(lineItems[i].dataset.id) === this.data[j].id) {
                ids.push(lineItems[i].dataset.id)

                this.payoutTotal += parseFloat(this.data[j].commission_amount)
              }
            }
          }
        }
      }

      this.reviewLineItems = ids
      this.selectedOrders = ids.length

      if (this.total > 50) {
        this.selectedAll = all
      } else {
        this.selectedAll = false
      }
    },
    undoAll () {
      this.undoSelectAll = false
      this.itemsSelected(true)
    },
    getLineItemTotal () {
      this.request('get', '/vendors/unpaid-commissions/' + this.vendorId + '/', {
        'date_start': this.params['date_start'],
        'date_end': this.params['date_end']
      }).then(response => {
        this.reviewLineItems = response.line_items
        this.selectedOrders = response.count
        this.payoutTotal = response.amount
        this.undoSelectAll = true
      })
    },
    addPayout () {
      this.reviewPayout = true
    },
    closePayout (reload) {
      this.reviewPayout = false

      if (reload) {
        this.getData()
      }
    },
    dateFilter (startDate, endDate) {
      if (startDate.length > 0) {
        this.params['date_start'] = startDate
      } else {
        delete this.params['date_start']
      }

      if (endDate.length > 0) {
        this.params['date_end'] = endDate
      } else {
        delete this.params['date_end']
      }

      this.getData()
    },
    paidFilter (paid) {
      if (paid !== null) {
        this.params['paid'] = paid
      } else {
        delete this.params['paid']
      }

      this.getData()
    },
    editCommission (lineItem, value) {
      this.editingCommission = true
      this.editingLineItem = lineItem
      this.editingCommissionValue = value
    },
    closeCommission () {
      this.editingCommission = false
    },
    saveCommission () {
      this.loading = true

      let commission = document.getElementById('commission-override').value

      commission = commission.replace('$', '')
      commission = commission.replace('%', '')

      // this.request('post', '/vendors/override-commission/create/', {
      //   line_item: this.editingLineItem,
      //   commission: commission
      // }).then(response => {
      //   this.editingCommission = false
      //   this.getData()
      // })

      if (commission === '') {
        commission = null
      }

      this.editingCommission = false

      if (this.editingLineItem.override_commission_line_item.length > 0) {
        this.request('put', '/vendors/override-commission/' + this.editingLineItem.override_commission_line_item[0].id + '/update/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      } else {
        this.request('post', '/vendors/override-commission/create/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      }
    },
    buildTable () {
      this.reviewLineItems = []
      this.selectedOrders = 0
      this.payoutTotal = 0
      this.undoSelectAll = false
      this.selectedAll = false

      let lineItems = this.data

      for (let i = 0; i < lineItems.length; i++) {
        lineItems[i].date = moment(lineItems[i].order.processed_at).format('MMM D, YYYY [at] h:mma')
        lineItems[i].financial_status = 'paid'
        lineItems[i].financialLabel = 'success'
        lineItems[i].customer_name = 'N/A'

        this.price = this.formatMoney(this.data.price)

        lineItems[i].fulfillmentStatus = lineItems[i].fulfillment_status

        if (lineItems[i].fulfillment_status === 'partial') {
          lineItems[i].fulfillmentLabel = 'warning'
          lineItems[i].fulfillmentStatus = 'Partially Fulfilled'
        } else if (lineItems[i].fulfillment_status === 'restocked' ||
          lineItems[i].fulfillment_status === null) {
          lineItems[i].fulfillmentLabel = 'alert'
        } else {
          lineItems[i].fulfillmentLabel = 'success'
        }

        if (lineItems[i].fulfillment_status === null) {
          lineItems[i].fulfillmentStatus = 'Unfulfilled'
        }

        lineItems[i].fulfillmentStatus = this.formatText(lineItems[i].fulfillmentStatus)

        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (lineItems[i].variant && !this.isEmpty(lineItems[i].variant.image) && lineItems[i].variant.image !== undefined && lineItems[i].variant.image.src !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].variant.image.src + '">'
          primary += '</div>'
        } else if (lineItems[i].image.length > 0) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItems[i].variant !== null) {
          if (lineItems[i].variant.product !== null) {
            primary += '</div></div><div class="cell auto" style="overflow: hidden; text-overflow: ellipsis;"><span style="white-space: nowrap;">' + lineItems[i].variant.product.title + '</span>'
          } else {
            primary += '</div></div><div class="cell auto">'
          }

          if (lineItems[i].variant !== null && lineItems[i].variant.title !== null && lineItems[i].variant.title.length > 0 && lineItems[i].variant.title !== 'Default Title') {
            primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].variant.title + '</i></small></span>'
          }
        } else {
          primary += '</div></div><div class="cell auto">'

          if (lineItems[i].title !== null && lineItems[i].title.length > 0) {
            primary += '<span class="text-overflow">' + lineItems[i].title + '</span>'
          } else {
            primary += '<span class="text-overflow">' + lineItems[i].name + '</span>'
          }
        }

        if (lineItems[i].sku !== null && lineItems[i].sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let price = '<div class="grid-x align-middle"><div class="cell shrink">' + this.formatMoney(lineItems[i].price)

        if (lineItems[i].allocated_discount > 0) {
          price += '<div class="text-right">-' + this.formatMoney(lineItems[i].allocated_discount) + '</div>'
        }

        if (this.$store.state.shop.myshopify_domain === 'mostlymusic.myshopify.com') {
          price += '</div><div class="cell auto text-right" style="white-space: nowrap;"></div></div>'
        } else {
          price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItems[i].quantity + '</div></div>'
        }

        // let checkbox = lineItems[i].id
        let commission = this.formatMoney(lineItems[i].commission_amount)

        let commissionCol = {
          value: commission,
          span: 'focus-text',
          edit: true,
          callback: 'editCommission',
          callbackArgs: [lineItems[i], null]
        }

        if (lineItems[i].commission_type === 'override') {
          commission = '*' + commission

          commissionCol['value'] = commission
          commissionCol['callbackArgs'] = [lineItems[i], lineItems[i].commission_amount.toFixed(2)]
        }

        if (lineItems[i].vendor_paid) {
          // checkbox = 'PAID'
          commissionCol['value'] = '<strike>' + commission + '</strike>'
          commissionCol['edit'] = false
          commissionCol['callback'] = null
        }

        if (!this.payments) {
          commissionCol = {
            value: commission,
            span: 'focus-text'
          }
        }

        let order = {
          value: lineItems[i].order.name,
          link: '/orders/' + lineItems[i].order.id
        }

        if (!this.payments) {
          // checkbox = false

          order = {
            value: lineItems[i].order.name
          }
        }

        let costPerItem = 0.0

        if (lineItems[i].variant && lineItems[i].variant.cost_per_item) {
          costPerItem = lineItems[i].variant.cost_per_item
        }

        let costCol = {
          value: this.formatMoney(costPerItem),
          span: 'fill',
          class: 'show-for-xlarge'
        }

        if (this.$store.state.shop.myshopify_domain === 'celebrityowned.myshopify.com') {
          costCol = {}
        }

        let locationCol = {
          value: '',
          class: 'medium'
        }

        if (lineItems[i].order.location) {
          locationCol['value'] = lineItems[i].order.location.name
        }

        if (this.$store.state.shop.myshopify_domain !== 'it-takes-a-village-co.myshopify.com') {
          locationCol = {}
        } else {
          costCol = {}
        }

        this.tableData.push({
          post: lineItems[i].id,
          checkbox: false,
          data: [
            order,
            {
              value: primary,
              class: 'full'
            },
            // {
            //   value: lineItems[i].customer_name,
            //   class: 'medium show-for-xlarge'
            // },
            // {
            //   value: this.formatText(lineItems[i].fulfillment_status),
            //   class: 'medium',
            //   span: 'label ' + lineItemFulfillmentStatus
            // },
            locationCol,
            {
              value: price,
              span: 'fill'
            },
            costCol,
            commissionCol,
            {
              value: lineItems[i].date,
              class: 'large hide-for-medium-only hide-for-large-only'
            }
          ]
        })
      }

      // for (let i = 0; i < this.tableData.length; i++) {
      //   this.request('get', '/vendors/' + this.tableData[i].vendor + '/').then(response => {
      //     this.tableData[i].data.pop()
      //   })
      // }
    }
  },
  created: function () {
    if (this.$store.state.shop.myshopify_domain === 'celebrityowned.myshopify.com') {
      this.tableHeader.data[3] = {}
    }

    if (this.$store.state.shop.myshopify_domain !== 'it-takes-a-village-co.myshopify.com') {
      this.tableHeader.data[2] = {}
    } else {
      this.tableHeader.data[4] = {}
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/unpaid.vue